<template>
  <div class="opdrachtPopUp">
    <i @click="close()" class="far fa-times-circle closePopUp"></i>
    <!-- 
          Contactgegevens sectie
         -->
    <div class="contactgegevensContainer">
      <transition-group name="pfSlideIn">
        <div key="1" @click="picturePop = false" v-if="picturePop" class="zoomedPicture">
          <img v-if="selectedUser.profilePictureURL" :src="selectedUser.profilePictureURL" />
          <img v-if="!selectedUser.profilePictureURL" src="../../../../assets/noProfilePicture.png" alt="" />
        </div>
      </transition-group>
      <div class="contactgegevensTop">
        <img
          @click="picturePop = !picturePop"
          v-if="selectedUser.profilePictureURL"
          :src="selectedUser.profilePictureURL"
          alt=""
        />
        <img v-if="!selectedUser.profilePictureURL" src="../../../../assets/noProfilePicture.png" alt="" />
        <div>
          <h4 class="capitalize" v-if="selectedUser.voornaam">{{ selectedUser.voornaam.toLowerCase() || '' }}</h4>
          <h4 class="capitalize" v-if="selectedUser.achternaam">{{ selectedUser.achternaam.toLowerCase() || '' }}</h4>
        </div>
      </div>
      <div class="contactWrapper">
        <a :href="`mailto:${selectedUser.email}`">
          <div class="contactGegevens">
            <i class="far fa-envelope-open"></i>
            <span>{{ selectedUser.email }}</span>
          </div>
        </a>
        <a :href="`tel:${selectedUser.telefoon}`">
          <div class="contactGegevens">
            <i class="far fa-phone-alt"></i>
            <span>{{ selectedUser.telefoon }}</span>
          </div>
        </a>
      </div>
    </div>
    <!-- 
          NAW gegevens sectie
         -->
   <div class="contentContainer">
      <div class="contentTop" @click="openSlideForCategorieNAW = !openSlideForCategorieNAW">
        <div class="ag_contentTitle"><i class="fas fa-user-edit"></i>NAW Gegevens</div>
        <i v-if="!openSlideForCategorieNAW" class="fas fa-chevron-down"></i>
        <i v-if="openSlideForCategorieNAW" class="fas fa-chevron-up"></i>
      </div>
      <div class="wrapperForSlide" :class="{ wrapperOpen: openSlideForCategorieNAW }">
        <div class="ag_content">
          <div class="ag_content_Left">
            <span
              ><strong> Beschikbaarheid: </strong> {{ selectedUser.beschikbaarheidInUrenPerWeek }} uur per week</span
            >
            <span><strong> Leeftijd:</strong> {{ getAge(selectedUser.geboortedatum) }}</span>
            <span><strong>Hoogste opleiding:</strong> {{ selectedUser.hoogstGenotenOpleiding }}</span>
          </div>
          <div class="ag_content_Right">
            <span v-if="selectedUser.beschikbaar"><strong>Beschikbaar:</strong> Ja</span>
            <span v-if="!selectedUser.beschikbaar"><strong>Beschikbaar:</strong> Nee</span>
            <span><strong> Aantal jaar ervaring:</strong> {{ selectedUser.aantalJaarErvaring }}</span>
            <span class="capitalize" v-if="selectedUser.plaats"><strong> Woonplaats:</strong> {{ selectedUser.plaats.toLowerCase() }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 
          Bedrijfsgegevens
         -->
    <div class="contentContainer">
      <div class="contentTop" @click="openSlideForCategorieBG = !openSlideForCategorieBG">
        <div class="ag_contentTitle">
          <span>
            <i class="far fa-building"></i>
            Bedrijfsgegevens
          </span>
        </div>
        <i v-if="!openSlideForCategorieBG" class="fas fa-chevron-down"></i>
        <i v-if="openSlideForCategorieBG" class="fas fa-chevron-up"></i>
      </div>
      <div class="wrapperForSlide" :class="{ wrapperOpen: openSlideForCategorieBG }">
        <div class="ag_content">
          <div class="ag_content_Left">
            <span><strong>Bedrijfsnaam:</strong> {{ selectedUser.bedrijfsnaam }}</span>
            <span><strong>KVK Nummer:</strong> {{ selectedUser.kvknummer }}</span>
            <span v-if="selectedUser.website"
              ><strong>Website:</strong>
              <a :href="`${selectedUser.website}`" target="_blank"> {{ selectedUser.website }}</a></span
            >
          </div>
          <div class="ag_content_Right">
            <span><strong>Iban:</strong> {{ selectedUser.iban }}</span>
            <span><strong>BTW-Nummer:</strong> {{ selectedUser.btwnummer }}</span>
            <span><strong>Aantal jaar zelfstandig:</strong> {{ selectedUser.aantalJaarZelfstandig }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 
          WerkProfiel sectie
         -->
    <!-- <div class="werkProfiel"> -->
    <div class="contentContainer">
      <div @click="openSlideForCategorieWP = !openSlideForCategorieWP" class="contentTop">
        <span class="ag_contentTitle"><i class="fal fa-id-card"></i>Werkprofiel</span>
        <i v-if="!openSlideForCategorieWP" class="fas fa-chevron-down"></i>
        <i v-if="openSlideForCategorieWP" class="fas fa-chevron-up"></i>
      </div>
      <div>
        <div class="wrapperForSlide" :class="{ wrapperOpen: openSlideForCategorieWP }">
          <div class="wp_Item">
            <span><strong> Disciplines</strong></span>
            <div class="wp_ItemWrapper">
              <span
                class="disciplines capitalize"
                :style="dynamicBackgroundColor(d)"
                v-for="(d, index) in selectedUser.disciplines"
                :key="index"
                >{{ d }}</span
              >
              <span v-if="!selectedUser.disciplines || selectedUser.disciplines.length < 1" class="nietIngevuld"
                >Niet ingevuld</span
              >
            </div>
          </div>
          <div class="wp_Item">
            <span><strong>Berekeningen</strong> </span>
            <div class="wp_ItemWrapper">
              <span class="capitalize" v-for="b in selectedUser.berekeningen" :key="b">
                {{ b }}
              </span>
              <span v-if="selectedUser.berekeningen && selectedUser.berekeningen.length < 1 || !selectedUser.berekeningen" class="nietIngevuld"
                >Niet ingevuld</span
              >
            </div>
          </div>
          <div class="wp_Item">
            <span><strong> Nen2580</strong></span>
            <span v-for="n in selectedUser.nen2580Werkzaamheden" :key="n">{{ n }}</span>
            <span
              v-if="selectedUser.nen2580Werkzaamheden && selectedUser.nen2580Werkzaamheden.length < 1 || !selectedUser.nen2580Werkzaamheden"
              class="nietIngevuld"
              >Niet ingevuld</span
            >
          </div>
          <div class="wp_Item">
            <span><strong> Tekenprogramma's</strong></span>
            <div class="wp_ItemWrapper">
              <span class="capitalize" v-for="t in selectedUser.tekenprogrammas" :key="t">{{ t }}</span>
              <span
                v-if="!selectedUser.tekenprogrammas || selectedUser.tekenprogrammas.length < 1"
                class="nietIngevuld"
                >Niet ingevuld</span
              >
            </div>
          </div>
          <div class="wp_Item">
            <span><strong> Aanvullende Applicaties</strong></span>
            <div class="wp_ItemWrapper">
              <span class="capitalize" v-for="a in selectedUser.aanvullendeApplicaties" :key="a">{{ a }}</span>
              <span
                v-if="!selectedUser.aanvullendeApplicaties || selectedUser.aanvullendeApplicaties.length < 1"
                class="nietIngevuld"
                >Niet ingevuld</span
              >
            </div>
          </div>

          <div class="wp_Item">
            <span><strong> Hoogste opleiding </strong></span>
            <p>{{ selectedUser.hoogstGenotenOpleiding }}</p>
            <span v-if="!selectedUser.hoogstGenotenOpleiding" class="nietIngevuld">Niet ingevuld</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 
      Voorkeuren
     -->
    <div class="contentContainer">
      <div @click="openSlideForCategorieVK = !openSlideForCategorieVK" class="contentTop">
        <span class="ag_contentTitle">
          <i class="far fa-heart"></i>
          Voorkeuren
        </span>
        <i v-if="!openSlideForCategorieVK" class="fas fa-chevron-down"></i>
        <i v-if="openSlideForCategorieVK" class="fas fa-chevron-up"></i>
      </div>
      <div class="wrapperForSlide" :class="{ wrapperOpen: openSlideForCategorieVK }">
        <div class="wp_Item">
          <span><strong>Werkgebied</strong></span>
          <div class="wp_ItemWrapper">
            <span v-for="w in selectedUser.werkgebied" :key="w" class="capitalize">
              {{ w }}
            </span>
            <span v-if="!selectedUser.werkgebied || selectedUser.werkgebied.length < 1" class="nietIngevuld"
              >Niet ingevuld</span
            >
          </div>
        </div>
        <div class="wp_Item">
          <span><strong>Werkplek</strong></span>
          <div class="wp_ItemWrapper">
            <span v-for="p in selectedUser.werkplek" :key="p" class="capitalize">
              {{ p }}
            </span>
            <span v-if="!selectedUser.werkplek || selectedUser.werkplek.length < 1" class="nietIngevuld"
              >Niet ingevuld</span
            >
          </div>
        </div>
        <div class="wp_Item">
          <span><strong>Type Opdrachten</strong></span>
          <div class="wp_ItemWrapper">
            <span v-for="t in selectedUser.voorkeurTypeOpdrachten" :key="t">{{ t }}</span>
            <span
              v-if="!selectedUser.voorkeurTypeOpdrachten || selectedUser.voorkeurTypeOpdrachten.length < 1"
              class="nietIngevuld"
              >Niet ingevuld</span
            >
          </div>
        </div>
        <div class="wp_Item">
          <span><strong>Particuliere opdrachten</strong></span>
          <span v-if="selectedUser.openVoorParticulierWerk">Ja</span>
          <span v-if="selectedUser.openVoorParticulierWerk === false">Nee</span>
        </div>
        <div class="wp_Item">
          <span><strong> Ambities</strong></span>
          <div class="wp_ItemWrapper">
            <p>{{ selectedUser.ambities }}</p>
            <span v-if="!selectedUser.ambities" class="nietIngevuld">Niet ingevuld</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 

      Kwaliteiten

     -->
    <div class="contentContainer">
      <div @click="openSlideForCategorieKW = !openSlideForCategorieKW" class="contentTop">
        <span class="ag_contentTitle"> <i class="fad fa-stars"></i>Kwaliteiten </span>
        <i v-if="!openSlideForCategorieKW" class="fas fa-chevron-down"></i>
        <i v-if="openSlideForCategorieKW" class="fas fa-chevron-up"></i>
      </div>
      <div class="wrapperForSlide" :class="{ wrapperOpen: openSlideForCategorieKW }">
        <div class="wp_Item column">
          <span><strong>Competenties en persoonlijke eigenschappen</strong></span>
          <div class="wp_ItemWrapper">
            <span v-for="k in selectedUser.kwaliteiten" :key="k">{{ k }}</span>
            <span v-if="!selectedUser.kwaliteiten || selectedUser.kwaliteiten.length < 1" class="nietIngevuld"
              >Niet ingevuld</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { db } from '@/firebase'
// import Sidebar from '@/components/Sidebar'
import { getAge } from '@/assets/helpers'
import store from '../../../../store';

export default {
  data() {
    return {
      disciplines: [
      'bouwkunde',
      'werktuigbouwkunde',
      'installatietechniek',
      'elektrotechniek',
      'brandpreventie',
      'huisvesting',
      'plattegronden',
      'concepten -3d print'
    ],
      picturePop: false,
      openSlideForCategorieNAW: true,
      openSlideForCategorieBG: true,
      openSlideForCategorieWP: true,
      openSlideForCategorieVK: true,
      openSlideForCategorieKW: true,
      colors: [
      '#575fcf', //Purple
      '#ef5777', //Pink
      '#4bcffa', //Blue
      '#4cd137', //Green
      '#1e272e', //Dark
      '#ff3f34', //Red
      '#485460', //DarkGrey
      '#ffc048', //Orange
      '#fff200', //Yellow
      '#ffb8b8' //Pink
    ]
    }
  },
  methods: {
    close() {
      return store.state.selectedUserProfileId = null
    },
    getAge() {
      return getAge()
    },
    dynamicBackgroundColor(d) {
      // console.log(d);
      // return `background-color: red`
      const index = this.disciplines.indexOf(d)
      const color = this.colors[index]
      return `background-color: ${color}`
    }
  },

  computed: {
    tekenaars() {
      return store.state.tekenaars
    },
    selectedUser()  {
        return store.state.userAccounts.find(e => e.id === store.state.selectedUserProfileId)?.userProfile
        // return store.state.userAccounts[store.state.selectedUserProfileIndex]
      }
    // selectedUser() {
    //   // const id = this.selectedId
    //   const id = this.$store.state.selectedId
    //   return this.tekenaars.find(user => user.id === id).userProfile
    // }
  }
}
</script>

<style lang="sass" scoped>
@import '@/utilities/variables.sass'
@import '@/utilities/animations.sass'

.opdrachtPopUp
  position: fixed
  padding-bottom: 80px
  top: 0
  right: 0
  bottom: 0
  left: 45vw
  background-color: white
  overflow: hidden
  overflow-y: scroll
  z-index: 10
  box-shadow: 0 0 100px 200px rgba(0, 0, 0, 0.1)
  .closePopUp
    font-size: 24px
    position: absolute
    top: 10px
    right: 10px
    color: $lightGrey
    padding: 10px
    cursor: pointer
    transition: .2s
    &:hover
      transform: scale(1.1)
  .contactgegevensContainer
    border-bottom: 1px solid rgba(0, 0, 0, 0.2)
    padding: 40px 40px 20px 40px
    background-color: $darkGrey
    .zoomedPicture
      position: fixed
      height: 400px
      width: 400px
      background-color: $darkGrey
      border-radius: 14px
      overflow: hidden
      z-index: 7
      cursor: pointer
      img
        min-height: 400px
        width: 400px
    .contactgegevensTop
      text-transform: capitalize
      display: flex
      align-items: center
      color: white
      img
        object-fit: cover
        margin-right: 14px
        max-height: 60px
        min-height: 60px
        max-width: 60px
        min-width: 60px
        border-radius: 100%
        cursor: pointer
        transition: .3s
        z-index: 1
        &:hover
          transform: scale(1.05)

    .contactWrapper
      background-color: $lightGrey
      display: flex
      padding: 20px
      justify-content: space-between
      border-radius: 4px
      margin-top: 20px
      font-weight: 600
      a
        color: black
        text-decoration: none
      .contactGegevens
        transition: .2s
        i
          margin-right: 8px
          color: black
          transition: .2s
        &:hover
          color: $blue
          i
            color: $blue


  .contentContainer
    padding: $horizontalContentPadding
    .contentTop
      display: flex
      justify-content: space-between
      cursor: pointer
    .ag_contentTitle
      font-weight: 600
      color: $blue
      i
        margin-right: 4px
    .wrapperForSlide
      max-height: 0px
      overflow: hidden
      transition: .3s
    .wrapperOpen
      max-height: 600px
    .ag_content
      padding-top: 14px
      display: flex
      justify-content: space-between
      .ag_content_Left, .ag_content_Right
        display: flex
        flex-direction: column
        a
          margin-left: 4px
          text-decoration: none
          color: black
      .ag_content_Right
        align-items: flex-start

    .wp_Item
      display: flex
      justify-content: space-between
      align-items: flex-start
      border-bottom: 1px solid rgba(0, 0, 0, 0.1)
      padding: 14px 0 14px 0
      .wp_ItemWrapper
        margin-left: 14px
        display: flex
        flex-wrap: wrap
        span
          background-color: $lightGrey
          color: black
          padding: 4px 10px
          border-radius: 20px
          margin: 4px
          font-size: 14px
          transition: .2s
        .disciplines
          color: white
          font-weight: 500

  .nietIngevuld
    color: $red !important
    background-color: $lightRed !important
    padding: 4px 10px !important
    border-radius: 20px !important
    font-size: 14px
  .column
    flex-direction: column
</style>
